import React, {Component} from 'react';
import {css} from "@emotion/css";
import Statistics from "../../component/Statistics/Statistics";
import ReportTable from "../../component/ReportTable/ReportTable";
import {Helmet} from "react-helmet";
import {RouteInfo} from "../../route/RouteHelper";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import VerticalBarChart from "../Charts/VerticalBarChart";

const Dashboard = () => {

    const loading = useLoadingDispatcher()
    loading(setLoadingStateDispatch(false))



    return (
        <>
            <Helmet>
                <title>{RouteInfo.Dashboard.name}</title>
            </Helmet>
            <section
                className={css`
                  padding: 26px 0;
                  overflow: hidden;
                `}>
                <ul className="page-title-bread-crumb-container">
                    <li>داشبورد</li>
                </ul>

                <section
                    className={`${css`
                      padding: 16px 0;
                      margin-top: 40px;
                      display: flex;
                      flex-direction: column;
                    `}`}>
                    <Statistics/>
                    <ReportTable/>

                </section>
            </section>
        </>

    )
}

export default Dashboard;

// function prepareChartItemData(label,dataRange,backgroundColor) {
//     return {
//         label,
//         dataRange,
//         backgroundColor,
//     };
// }

// const chartData = {
//     Labels: ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'],
//     datasets: [
//         prepareChartItemData(
//             'گزارش اول',
//             [1, 6, 8, 5, 2, 9, 1, 7, 3, 8, 10, 14],
//             'rgba(255, 99, 132, 0.5)',
//
//         ),
//         prepareChartItemData(
//             'گزارش اول',
//             [1, 6, 8, 5, 2, 9, 1, 7, 3, 8, 10, 14],
//             'rgba(255, 99, 132, 0.5)',
//
//         ),
//     ]
//
// }

const chartOption={

}
